export default __webpack_public_path__ + "static/media/AdBlue_can18.f9fc5ab9.svg";